import { Box, Typography, IconButton, List, ListItemButton, Drawer, ListItemIcon } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import './BottomSheetDrawer.scss';
import { memo, type ReactNode } from 'react';

interface IProps {
  title: string;
  open: boolean;
  onClose: () => void;
  actions: {
    label: string;
    action: () => void;
    enable?: boolean;
    icon?: ReactNode;
    tone?: 'default' | 'danger';
  }[];
}

const BottomSheetDrawer = ({ title, open, onClose, actions }: IProps) => {
  return (
    <Drawer
      anchor="bottom"
      id="bottom-sheet-drawer"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderTopLeftRadius: 16,
          borderTopRightRadius: 16,
          bgcolor: 'var(--public-chat-bg)',
          color: 'var(--font-color)',
          maxHeight: '70vh',
        },
      }}
      BackdropProps={{
        sx: {
          backgroundColor: 'var(--drawer-backdrop-color)',
        },
      }}
      className="bottom-sheet-drawer"
    >
      <Box className="header">
        <IconButton className="close-icon" onClick={onClose} size="small">
          <CloseIcon fontSize="inherit" />
        </IconButton>

        <Typography className="title">{title || 'Default Title'}</Typography>
      </Box>

      <List className="list">
        {actions
          .filter((action) => action.enable !== false)
          .map((action, index) => (
            <ListItemButton
              className={`drawer-action ${action.tone === 'danger' ? 'danger' : ''}`}
              onClick={() => {
                onClose();
                action.action();
              }}
              style={{
                borderBottom: index < actions.length - 1 ? '0.5px solid #13191B' : 'none',
              }}
              key={action.label}
            >
            {action.icon && (
              <ListItemIcon className="drawer-action-icon">
                {action.icon}
              </ListItemIcon>
            )}
            <Typography component="span" className="drawer-action-label" sx={{ fontSize: 15, color: 'var(--font-color)' }}>
              {action.label}
            </Typography>
            </ListItemButton>
          ))}
      </List>
    </Drawer>
  );
};

export default memo(BottomSheetDrawer);
